export default {
  "content": "<g clip-path=\"url(#a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.333 10.989a6 6 0 11-6.666-9.977 6 6 0 016.666 9.977zM7 8.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-3 11a6.51 6.51 0 014.22-6.08A2 2 0 007 13H2a2 2 0 00-2 2v4.75a.25.25 0 00.25.25H4v-.5zm6.5-4.5h9a4.49 4.49 0 014.5 4.5v4a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5v-4a4.49 4.49 0 014.5-4.5z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};